import React, { useState, useRef, useEffect, useCallback } from "react";
import { Search, Building2 } from "lucide-react";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import NotificationBell from "./components/NotificationBell";
import { ToastProvider } from "./components/Toast";
import Sidebar, { MENU, roleColors, getMenuLabel } from "./components/Sidebar";
import { ROLE_LABELS, VIEWABLE_ROLES } from "./contexts/AuthContext";
import { dashboardAPI, masterAPI } from "./utils/api";
import { fmtRp } from "./utils/format";

import LoginPageReal from "./pages/LoginPage";
import DashboardPageReal from "./pages/DashboardPage";
import BudgetPageReal from "./pages/BudgetPage";
import RevisiAnggaranPageReal from "./pages/RevisiAnggaranPage";
import PaymentPageReal from "./pages/PaymentPage";
import PenerimaanPageReal from "./pages/PenerimaanPage";
import PengeluaranPageReal from "./pages/PengeluaranPage";
import MasterPageReal from "./pages/MasterPage";
import AdminPageReal from "./pages/AdminPage";

const LoginPage = LoginPageReal;
const DashboardPage = DashboardPageReal;
const BudgetPage = BudgetPageReal;
const RevisiAnggaranPage = RevisiAnggaranPageReal;
const PaymentPage = PaymentPageReal;
const PenerimaanPage = PenerimaanPageReal;
const PengeluaranPage = PengeluaranPageReal;
const MasterPage = MasterPageReal;
const AdminPage = AdminPageReal;
import PersonelPageReal from "./pages/personel/PersonelPage";
import BagtapyanPageReal from "./pages/bagtapyan/BagtapyanPage";
const PersonelPage = PersonelPageReal;
const BagtapyanPage = BagtapyanPageReal;
import BinkarPageReal from "./pages/binkar/BinkarPage";
const BinkarPage = BinkarPageReal;
import TahorPageReal from "./pages/tahor/TahorPage";
const TahorPage = TahorPageReal;
import MinseldikPageReal from "./pages/minseldik/MinseldikPage";
const MinseldikPage = MinseldikPageReal;
import DosirPageReal from "./pages/dosir/DosirPage";
const DosirPage = DosirPageReal;
import DoselPageReal from "./pages/dosel/DoselPage";
import PensiunPageReal from "./pages/pensiun/PensiunPage";
import KekuatanPageReal from "./pages/kekuatan/KekuatanPage";
import AssetPageReal from "./pages/assets/AssetPage";
import InventoryPageReal from "./pages/inventory/InventoryPage";
import ProcurementPageReal from "./pages/procurement/ProcurementPage";
import KontrakPageReal from "./pages/procurement/KontrakPage";
import ReportPageReal from "./pages/ReportPage";
import AuditTrailPageReal from "./pages/AuditTrailPage";
import BendaharaPageReal from "./pages/BendaharaPage";
import HrDashboardPageReal from "./pages/HrDashboardPage";

const DoselPage = DoselPageReal;
const PensiunPage = PensiunPageReal;
const KekuatanPage = KekuatanPageReal;
const AssetPage = AssetPageReal;
const InventoryPage = InventoryPageReal;
const ProcurementPage = ProcurementPageReal;
const KontrakPage = KontrakPageReal;
const BendaharaPage = BendaharaPageReal;
const HrDashboardPage = HrDashboardPageReal;
const ReportPage = ReportPageReal;
const AuditTrailPage = AuditTrailPageReal;

const PAGES = {
  dashboard: DashboardPage,
  budget: BudgetPage,
  revisi: RevisiAnggaranPage,
  penerimaan: PenerimaanPage,
  payment: PaymentPage,
  pengeluaran: PengeluaranPage,
  master: MasterPage,
  assets: AssetPage,
  inventory: InventoryPage,
  procurement: ProcurementPage,
  'procurement-pr': ProcurementPage,
  'procurement-kontrak': KontrakPage,
  bendahara: BendaharaPage,
  hr: HrDashboardPage,
  personel: PersonelPage,
  bagtapyan: BagtapyanPage,
  binkar: BinkarPage,
  minseldik: MinseldikPage,
  tahor: TahorPage,
  dosir: DosirPage,
  dosel: DoselPage,
  pensiun: PensiunPage,
  kekuatan: KekuatanPage,
  admin: AdminPage,
  reports: ReportPage,
  'audit-trail': AuditTrailPage,
};

const MODULE_COLORS = { ANGGARAN: "#2563EB", PROCUREMENT: "#D97706", KONTRAK: "#7C3AED", PAYMENT: "#059669" };

const GlobalSearch = ({ onNavigate }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const doSearch = useCallback((val) => {
    clearTimeout(timer.current);
    if (val.length < 2) { setResults([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try { const r = await dashboardAPI.search(val); setResults(r.data || []); setOpen(true); } catch {}
    }, 300);
  }, []);

  const handleNav = (item) => {
    setOpen(false); setQ("");
    const map = { ANGGARAN: "budget", PROCUREMENT: "procurement-pr", KONTRAK: "procurement-kontrak", PAYMENT: "payment" };
    onNavigate(map[item.module] || "dashboard");
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 6, background: "#F3F4F6", borderRadius: 8, padding: "5px 10px" }}>
        <Search size={14} color="#9CA3AF" />
        <input value={q} onChange={e => { setQ(e.target.value); doSearch(e.target.value); }} onFocus={() => results.length && setOpen(true)}
          placeholder="Cari nomor, keterangan..."
          style={{ border: "none", background: "none", outline: "none", fontSize: 12, width: 180, fontFamily: "inherit", color: "#374151" }} />
      </div>
      {open && results.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4, background: "white", borderRadius: 10, boxShadow: "0 8px 30px rgba(0,0,0,.12)", border: "1px solid #E5E7EB", maxHeight: 320, overflow: "auto", zIndex: 50, minWidth: 360 }}>
          {results.map((r, i) => (
            <button key={i} onClick={() => handleNav(r)}
              style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", width: "100%", border: "none", background: "none", cursor: "pointer", borderBottom: "1px solid #F3F4F6", textAlign: "left" }}
              onMouseEnter={e => e.currentTarget.style.background = "#F8FAFC"} onMouseLeave={e => e.currentTarget.style.background = "none"}>
              <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 6, background: MODULE_COLORS[r.module] + "18", color: MODULE_COLORS[r.module] }}>{r.module}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.nomor || '-'}</div>
                <div style={{ fontSize: 11, color: "#6B7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.label || '-'}</div>
              </div>
              <span style={{ fontSize: 11, fontFamily: "monospace", fontWeight: 600, color: "#374151", whiteSpace: "nowrap" }}>{fmtRp(Number(r.nilai) || 0)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const UnitSelector = () => {
  const { selectedUnitId, setSelectedUnitId, user } = useAuth();
  const [units, setUnits] = useState([]);
  useEffect(() => { masterAPI.getUnit().then(r => setUnits(r.data || [])).catch(() => {}); }, []);
  if (!user) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <Building2 size={14} color="#6B7280" />
      <select value={selectedUnitId || ''} onChange={e => setSelectedUnitId(e.target.value || null)}
        style={{ fontSize: 11, padding: "4px 8px", borderRadius: 6, border: "1px solid #D1D5DB", background: "white", fontWeight: 600, color: "#374151", cursor: "pointer", maxWidth: 160 }}>
        <option value="">Semua Unit</option>
        {units.map(u => <option key={u.id} value={u.id}>{u.nama}</option>)}
      </select>
    </div>
  );
};

const MainApp = () => {
  const { user, realUser, viewAsRole, setViewAsRole, isViewingAs } = useAuth();
  const [active, setActive] = useState("dashboard");
  const [collapsed, setCollapsed] = useState(false);
  const PageComponent = PAGES[active] || DashboardPage;
  const isAdmin = realUser?.role === 'ADMIN';

  return (
    <div style={{ display:"flex", minHeight:"100vh", background:"#F8FAFC", fontFamily:"'Inter',-apple-system,sans-serif" }}>
      <Sidebar active={active} setActive={setActive} collapsed={collapsed} setCollapsed={setCollapsed} />
      <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
        {isViewingAs && (
          <div style={{ background:"#FEF3C7", padding:"6px 24px", fontSize:12, fontWeight:600, color:"#92400E", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
            <span>Viewing as: {ROLE_LABELS[viewAsRole] || viewAsRole} (akun asli: {realUser?.name})</span>
            <button onClick={() => setViewAsRole(null)} style={{ background:"#92400E", color:"white", border:"none", borderRadius:6, padding:"3px 10px", fontSize:11, fontWeight:600, cursor:"pointer" }}>Kembali ke Admin</button>
          </div>
        )}
        <header style={{ background:"white", borderBottom:"1px solid #E5E7EB", padding:"0 24px", height:56, display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0 }}>
          <div>
            <span style={{ fontSize:13, color:"#9CA3AF" }}>IFMS /</span>
            <span style={{ fontSize:13, fontWeight:600, color:"#111827" }}>{getMenuLabel(active)}</span>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <UnitSelector />
            <GlobalSearch onNavigate={setActive} />
            {isAdmin && (
              <select value={viewAsRole || ''} onChange={e => setViewAsRole(e.target.value || null)}
                style={{ fontSize:11, padding:"4px 8px", borderRadius:6, border:"1px solid #D1D5DB", background: isViewingAs ? "#FEF3C7" : "white", fontWeight:600, color:"#374151", cursor:"pointer" }}>
                <option value="">View As…</option>
                {VIEWABLE_ROLES.filter(r => r !== 'ADMIN').map(r => (
                  <option key={r} value={r}>{ROLE_LABELS[r] || r}</option>
                ))}
              </select>
            )}
            <NotificationBell />
            <div style={{ fontSize:12, color:"#6B7280" }}>
              <span style={{ fontWeight:600, color:"#374151" }}>{user?.name}</span>
              <span style={{ margin:"0 6px" }}>·</span>
              <span style={{ color:roleColors[user?.role], fontWeight:600 }}>{ROLE_LABELS[user?.role] || user?.role}</span>
            </div>
          </div>
        </header>
        <main style={{ flex:1, padding:24, overflow:"auto" }}>
          <PageComponent />
        </main>
      </div>
    </div>
  );
};

const AppContent = () => {
  const { user } = useAuth();
  return user ? <MainApp /> : <LoginPage />;
};

const App = () => (
  <AuthProvider>
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  </AuthProvider>
);

export default App;